import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { UserConsentCollection } from './user-consent.types';

export function userConsentBackend(): Backend<UserConsentCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => {
      return {
        endpoint: 'user/consent.php',
        isGaf: true,
        params: {
          dataType: getQueryParamValue(query, 'dataType')[0],
          usageType: getQueryParamValue(query, 'usageType')[0],
          collectionLocation: getQueryParamValue(
            query,
            'collectionLocation',
          )[0],
        },
      };
    },
    push: (_, userConsent) => {
      return {
        endpoint: 'user/consent.php',
        method: 'POST',
        isGaf: true,
        payload: {
          dataType: userConsent.dataType,
          usageType: userConsent.usageType,
          consentGiven: userConsent.consentGiven,
          collectionLocation: userConsent.collectionLocation,
          dateCreated: userConsent.dateCreated
            ? Math.floor(userConsent.dateCreated / 1000)
            : undefined,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
